"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const unitsPerTile_1 = __importDefault(require("../constants/unitsPerTile"));
const state_1 = __importDefault(require("../state"));
const calculateActiveDestructibles_1 = __importDefault(require("./calculateActiveDestructibles"));
const startLevel = () => {
    var _a;
    (_a = document.getElementById("screen")) === null || _a === void 0 ? void 0 : _a.classList.add("main");
    state_1.default.bonked = false;
    state_1.default.pauses = [];
    state_1.default.levelCompletedAt = null;
    state_1.default.playedDefeatMusic = false;
    state_1.default.playedLevelMusic = false;
    state_1.default.isInBed = true;
    state_1.default.levelStartedAt = null;
    state_1.default.brokenDestructibleIDs = [];
    state_1.default.activeDestructibleIDs = [];
    state_1.default.hitObstacleAt = null;
    state_1.default.cootsVelocityX = 0;
    state_1.default.cootsVelocityY = 0;
    state_1.default.cootsCoords = {
        x: state_1.default.level.startingTileX * unitsPerTile_1.default,
        y: state_1.default.level.startingTileY * unitsPerTile_1.default
    };
    state_1.default.recentDestruction = null;
    (0, calculateActiveDestructibles_1.default)();
};
exports.default = startLevel;
